import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { setApgarGrimaceOptions } from '../store/options.actions'

import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getApgarGrimaceOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const apgarGrimace: IOptionsResponse = yield call([vitalsService, vitalsService.getApgarGrimace])
    const { entity } = apgarGrimace
    yield put(setApgarGrimaceOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getApgarGrimaceOptions() error: ${e}`))
  }
}

export function* getApgarGrimaceOptionsSaga() {
  yield takeLatest(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, getApgarGrimaceOptions)
}
